import React, {useEffect} from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplate } from 'react-simple-captcha';
// import PropTypes from 'prop-types';
import {  Grid, Paper } from '@material-ui/core';
import { TextField } from '@material-ui/core';


import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: '#555'
  },
}));
const CaptchaForm = props => {
    const classes = useStyles();
    // const {doSubmit } =props
    const mount = () => {
        const unmount = () => {
            loadCaptchaEnginge(4, '#555', '#FFFFFF');
        }
        return unmount()
    }
    useEffect(mount,  [])

    

    return (
        <div>
            <Grid container spacing={3}  >
                <Grid item xs={12} md={2} lg={2} xl={2} >
                    <Paper className={classes.paper}><LoadCanvasTemplate reloadText="Cambiar"   reloadColor="#6FAC22" style={{backgroundColor: '#6FAC22'}} /></Paper>
                    
                </Grid>
                <Grid item xs={12} md={10} lg={10} xl={10}>
                    <TextField id="user_captcha_input" label="Por favor digite el código de la imagen" variant="outlined" name="user_captcha_input" fullWidth/>
                </Grid>
            </Grid>
       </div>
    );
};

CaptchaForm.propTypes = {
    
};

export default CaptchaForm;